import type { ScaleLinear, ScaleTime } from 'd3-scale';

interface Props {
  data: number[];
  xSelect: (date: number) => number;
  ySelect: (date: number) => number;
  xScale: ScaleTime<number, number>;
  yScale: ScaleLinear<number, number>;
  fill?: string;
  startX?: number;
  endX?: number;
}

const Waypoints = ({
  data,
  xSelect,
  ySelect,
  xScale,
  yScale,
  fill = 'white',
  startX,
  endX,
}: Props) => {
  const start = startX || 0;
  const end = endX || xScale.domain()[1];
  return (
    <svg y="0" x="0" width="100%" height="100%">
      {data
        .filter((d) => xSelect(d) >= start && xSelect(d) <= Number(end))
        .map((d) => (
          <circle
            key={`waypoint-${d}`}
            transform={`translate(${xScale(xSelect(d))} ${yScale(ySelect(d))})`}
            r="4"
            fill={fill}
          />
        ))}
    </svg>
  );
};

export default Waypoints;
